


import {Person} from "../../models/person-viewmodel";

import ResultDetailsComponent from '../ResultDetails/ResultDetails.vue'
import {defineComponent, PropType} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
  name: "Result",
  components: {
    ResultDetailsComponent
  },
  props: {
    result: {type: Object as PropType<Person>}
  },
  setup: () => {
    const {labels} = useGetters(['labels'])

    return {
      labels
    }
  }
})
